import { message, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useGetVCEByOrderId, useUpdateOrderStatus } from "../../api/order";

type AdminUpdateOrderModalProps = {
  open: boolean;
  selectedId: string;
  orderStatus:
    | "ACCEPTED"
    | "DELIVERED"
    | "INPROGRESS"
    | "PENDING"
    | "REJECTED"
    | "COMPLETED"
    | undefined;
  hideModal: () => void;
};

const AdminUpdateOrderModal: React.FC<AdminUpdateOrderModalProps> = ({
  open,
  orderStatus,
  selectedId,
  hideModal,
}) => {
  const [status, setStatus] = useState<
    | "ACCEPTED"
    | "DELIVERED"
    | "INPROGRESS"
    | "PENDING"
    | "REJECTED"
    | "COMPLETED"
    | undefined
  >();
  const { data: orderDetail } = useGetVCEByOrderId(selectedId);

  const { mutateAsync: updateOrder, isPending } = useUpdateOrderStatus();

  const onsubmit = async () => {
    try {
      const result = await updateOrder({
        orderId: selectedId,
        status: status?.toString(),
      });

      if (result.status === 200) {
        message.success("Update successful.");
      }
    } catch (err: any) {
      message.error("Operation failed.");
    } finally {
      hideModal();
    }
  };

  useEffect(() => {
    if (orderStatus) {
      setStatus(orderStatus);
    }
  }, [orderStatus]);

  useEffect(() => {
    if (orderDetail && orderDetail.data && orderDetail.data.data) {
      if (orderDetail.data) {
        const _target: React.Key[] = orderDetail.data.data.map(
          (o: any) => o.id
        );

        setTargetKeys(_target);
      }
    }
  }, [orderDetail]);

  const [, setTargetKeys] = useState<React.Key[]>();

  return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 27.43,
            color: "black",
          }}
        >
          Edit order
        </div>
      }
      open={open}
      centered
      onOk={onsubmit}
      okButtonProps={{
        disabled: isPending,
        loading: isPending,
      }}
      onCancel={hideModal}
      closable
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <Select
          value={status}
          placeholder="Select category"
          style={{ width: "100%" }}
          onChange={(val: any) => setStatus(val)}
          options={[
            "ACCEPTED",
            "COMPLETED",
            "DELIVERED",
            "INPROGRESS",
            "PENDING",
            "REJECTED",
          ].map((_status: string) => {
            return { label: _status, value: _status };
          })}
        />
      </div>
    </Modal>
  );
};

export default AdminUpdateOrderModal;
